export const AP_TRAINING_LOADER = {
  desktop: `<div class="cui">
  <div class="cui-grid cui-container">
    <div class="cui-skeleton-paragraph -spacing--bottom-64 -spacing--top-40">
      <div class="cui-skeleton-paragraph__content" style="width: 100%;">
        <div class="cui-skeleton__item" style="height: 16px;"></div>
      </div>
    </div>
    <div class="cui-skeleton-heading -size--large -spacing--bottom-24 -resolution--desktop">
      <div class="cui-skeleton-heading__content" style="width: 100%;">
        <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 52px;"></div>
      </div>
    </div>
    <div class="cui-row -spacing--top-64">
      <div class="cui-col-lg-4 -spacing--bottom-16">
        <div class="cui-skeleton-heading -size--large -resolution--desktop">
          <div class="cui-skeleton-heading__content" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
          </div>
        </div>
      </div>
      <div class="cui-col-lg-8">
        <div class="cui-skeleton-paragraph -size--large -resolution--desktop">
          <div class="cui-skeleton-paragraph__content" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
        <div class="cui-skeleton-button -size--large -spacing--top-40">
          <div class="cui-skeleton-button__content" style="width: 154px;">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="cui-row -spacing--bottom-80" style="margin-top: 128px;">
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 188px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-heading -size--medium -resolution--desktop">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 188px;"></div>
          </div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 188px;"></div>
        </div>
      </div>
    </div>
    <div class="cui-skeleton-paragraph -size--large -resolution--desktop">
      <div class="cui-skeleton-paragraph__content" style="width: 100%;">
        <div class="cui-skeleton__item cui-skeleton__description" style="max-width: 730px; height: 40px;"></div>
        <div class="cui-skeleton__item cui-skeleton__description -spacing--top-40 -spacing--bottom-120" style="max-width: 951px; height: 64px;"></div>
      </div>
    </div>
    <div class="cui-row -spacing--top-64">
      <div class="cui-col-lg-4 -spacing--bottom-16">
        <div class="cui-skeleton-heading -size--large -resolution--desktop">
          <div class="cui-skeleton-heading__content" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
          </div>
        </div>
      </div>
      <div class="cui-col-lg-8">
        <div class="cui-skeleton-paragraph -size--large -resolution--desktop">
          <div class="cui-skeleton-paragraph__content" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
        <div class="cui-skeleton-button -size--large -spacing--top-40">
          <div class="cui-skeleton-button__content" style="width: 154px;">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 128px;">
      <div class="cui-skeleton-heading -size--medium -spacing--bottom-40 -resolution--desktop">
        <div class="cui-skeleton-heading__content" style="width: max(300px, 100%); height: 40px;">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>
      <div class="cui-row">
        <div class="cui-col-lg-4 -spacing--bottom-24">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 320px;"></div>
          </div>
        </div>
        <div class="cui-col-lg-4 -spacing--bottom-24">
          <div class="cui-skeleton-heading -size--medium -resolution--desktop">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 320px;"></div>
            </div>
          </div>
        </div>
        <div class="cui-col-lg-4 -spacing--bottom-24">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 320px;"></div>
          </div>
        </div>
      </div>
      <div class="-spacing--top-40">
        <span class="cui-skeleton-button -size--large -spacing--right-8">
          <div class="cui-skeleton-button__content" style="width: 48px;">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </span>
        <span class="cui-skeleton-button -size--large">
          <div class="cui-skeleton-button__content" style="width: 48px;">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </span>
      </div>
    </div>
    <div style="margin-top: 128px;">
      <div class="cui-skeleton-heading -size--medium -spacing--bottom-40 -resolution--desktop">
        <div class="cui-skeleton-heading__content" style="max-width: 730px; width: 100%;">
          <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 40px;"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-row">
        <div class="cui-col-lg-3 -spacing--bottom-24">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 440px;"></div>
          </div>
        </div>
        <div class="cui-col-lg-3 -spacing--bottom-24">
          <div class="cui-skeleton-heading -size--medium -resolution--desktop">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 440px;"></div>
            </div>
          </div>
        </div>
        <div class="cui-col-lg-3 -spacing--bottom-24">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 440px;"></div>
          </div>
        </div>
        <div class="cui-col-lg-3 -spacing--bottom-24">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 440px;"></div>
          </div>
        </div>
      </div>
      <div class="-spacing--top-40">
        <span class="cui-skeleton-button -size--large -spacing--right-8">
          <div class="cui-skeleton-button__content" style="width: 48px;">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </span>
        <span class="cui-skeleton-button -size--large">
          <div class="cui-skeleton-button__content" style="width: 48px;">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </span>
      </div>
    </div>
    <div style="margin-top: 128px;">
      <div class="cui-skeleton-heading -size--medium -spacing--bottom-40 -resolution--desktop">
        <div class="cui-skeleton-heading__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 40px;"></div>
        </div>
      </div>
      <div class="cui-row">
        <div class="cui-col-lg-3 -spacing--bottom-24">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 152px;"></div>
          </div>
        </div>
        <div class="cui-col-lg-3 -spacing--bottom-24">
          <div class="cui-skeleton-heading -size--medium -resolution--desktop">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 152px;"></div>
            </div>
          </div>
        </div>
        <div class="cui-col-lg-3 -spacing--bottom-24">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 152px;"></div>
          </div>
        </div>
        <div class="cui-col-lg-3 -spacing--bottom-24">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 152px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="cui-skeleton-rectangle -is--block -spacing--top-96">
    <div class="cui-skeleton__item" style="width: 100%; height: 124px;"></div>
  </div>
</div>`,
  mobile: `
<div class="cui">
  <div class="cui-grid cui-container">
    <div class="cui-skeleton-paragraph -spacing--top-16 -spacing--bottom-40">
      <div class="cui-skeleton-paragraph__content" style="width: 100%;">
        <div class="cui-skeleton__item" style="height: 16px;"></div>
      </div>
    </div>
    <div class="cui-skeleton-heading -size--large -spacing--bottom-24 -resolution--mobile">
      <div class="cui-skeleton-heading__content" style="width: 100%;">
        <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 40px;"></div>
      </div>
    </div>
      <div class="-spacing--top-48 -spacing--bottom-16">
        <div class="cui-skeleton-heading -size--large -resolution--mobile">
          <div class="cui-skeleton-heading__content" style="width: 100%">
            <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 40px"></div>
            <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
            <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          </div>
        </div>
      </div>
      <div class="cui-skeleton-button -size--large -spacing--top-24 -spacing--bottom-24">
        <div class="cui-skeleton-button__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton-button__button"></div>
        </div>
      </div>
    <div class="-spacing--bottom-24">
      <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 180px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 180px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 180px;"></div>
      </div>
    </div>
    <div class="cui-skeleton-paragraph -size--large -resolution--mobile">
      <div class="cui-skeleton-paragraph__content" style="width: 100%;">
        <div class="cui-skeleton__item cui-skeleton__description -spacing--top-24" style="max-width: 200px; height: 36px;"></div>
        <div class="cui-skeleton__item cui-skeleton__description -spacing--top-24" style="max-width: 951px; height: 64px;"></div>
        <div class="cui-skeleton__item cui-skeleton__description -spacing--top-24 -spacing--bottom-24" style="max-width: 951px; height: 64px;"></div>
      </div>
    </div>
    <div class="-spacing--top-24">
      <div class="-spacing--bottom-16">
        <div class="cui-skeleton-heading -size--large -resolution--mobile">
          <div class="cui-skeleton-heading__content" style="width: 100%">
            <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 36px"></div>
            <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
            <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          </div>
        </div>
        <div class="cui-skeleton-button -size--large -spacing--top-24 -spacing--bottom-24">
        <div class="cui-skeleton-button__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton-button__button"></div>
        </div>
      </div>
      </div>
    </div>
      <div style="margin-top: 56px;" class="cui-skeleton-heading -size--medium -spacing--bottom-16 -resolution--mobile">
        <div class="cui-skeleton-heading__content" style="width: max(300px, 100%); height: 40px;">
          <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 36px;"></div>
        </div>
      </div>
      </div>
      <div class="cui-grid">
      <div class="cui-row" style="margin: 0 ; padding-right: 0 ;">
        <div class="cui-col-sm -spacing--bottom-24" style="padding-left: 15px;">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="min-width: 320px; height: 240px;"></div>
          </div>
        </div>
        <div class="cui-col-sm -spacing--bottom-24" style="margin-right: 0px; padding-right: 0px;">
          <div class="cui-skeleton-heading -size--medium -resolution--mobile">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 240px;"></div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="cui-grid cui-container">
      <div>
        <span class="cui-skeleton-button -size--large -spacing--right-8">
          <div class="cui-skeleton-button__content" style="width: 48px;">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </span>
        <span class="cui-skeleton-button -size--large">
          <div class="cui-skeleton-button__content" style="width: 48px;">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </span>
      </div>
      <div class="cui-skeleton-heading -size--medium -spacing--bottom-24 -resolution--mobile" style="margin-top: 56px;">
        <div class="cui-skeleton-heading__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 36px;"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      </div>
      <div class="cui-grid">
      <div class="cui-row" style="margin: 0 ; padding-right: 0 ;">
        <div class="cui-col-sm -spacing--bottom-24" style="padding-left: 15px;">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="min-width: 297px; height: 384px;"></div>
          </div>
        </div>
        <div class="cui-col-sm -spacing--bottom-24" style="margin-right: 0px; padding-right: 0px;">
          <div class="cui-skeleton-heading -size--medium -resolution--mobile">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 384px;"></div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="cui-grid cui-container">
      <div>
        <span class="cui-skeleton-button -size--large -spacing--right-8">
          <div class="cui-skeleton-button__content" style="width: 48px;">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </span>
        <span class="cui-skeleton-button -size--large">
          <div class="cui-skeleton-button__content" style="width: 48px;">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </span>
      </div>
    <div style="margin-top: 48px;">
      <div class="cui-skeleton-heading -size--medium -spacing--bottom-24 -resolution--mobile">
        <div class="cui-skeleton-heading__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 36px;"></div>
        </div>
      </div>
        <div class="cui-skeleton-heading -size--medium -spacing--bottom-24 -resolution--mobile">
        <div class="cui-skeleton-heading__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 20px;"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--medium -spacing--bottom-24 -resolution--mobile">
        <div class="cui-skeleton-heading__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 20px;"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--medium -spacing--bottom-24 -resolution--mobile">
        <div class="cui-skeleton-heading__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 20px;"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--medium -spacing--bottom-24 -resolution--mobile">
        <div class="cui-skeleton-heading__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 20px;"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
    </div>
    </div>
  <div class="cui-skeleton-rectangle -is--block -spacing--top-64">
    <div class="cui-skeleton__item" style="width: 100%; height: 220px;"></div>
  </div>
</div>`
};
